import React from 'react';
import Loader from "./Loader";
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

const FIELD_VALUE_FONT = {
    fontFamily: "'Archivo Expanded', sans-serif",
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '19px',
    color: '#5B595B',
};

const selectStyles = {
    control: (base, { isDisabled }) => ({ ...base, borderRadius: 0, border: '4px solid #F2F2F2', backgroundColor: isDisabled ? 'rgba(178, 178, 178, 0.13)' : base.backgroundColor }),
    menu: (base) => ({ ...base, borderRadius: 0 }),
    menuList: (base) => ({ ...base, borderRadius: 0 }),
    dropdownIndicator: (base, { isDisabled }) => ({ ...base, display: isDisabled ? 'none' : 'flex' }),
    indicatorSeparator: () => ({ display: 'none' }),
    option: (base, { data, options, isSelected, isFocused }) => ({
        ...base,
        backgroundColor: isSelected ? '#BCBEC0' : isFocused ? '#D5D6D8' : options.indexOf(data) % 2 === 0 ? '#EEEFF0' : '#FFFFFF',
        color: '#5B595B',
        fontFamily: "'Archivo Expanded', sans-serif",
    }),
    placeholder: (base) => ({ ...base, color: '#B3B3B3', fontStyle: 'italic', fontFamily: "'Archivo', sans-serif", fontSize: '20px' }),
    singleValue: (base) => ({ ...base, ...FIELD_VALUE_FONT }),
    input: (base) => ({ ...base, ...FIELD_VALUE_FONT }),
};

const HR_STYLE = {
    height: 0,
    border: 'none',
    borderTop: '3px solid #ccc',
    margin: '0 25px',
};

const BUTTON_STYLE = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    height: '48px',
    fontFamily: "'Archivo Expanded', sans-serif",
    fontSize: '25px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    padding: '8px 25px',
    border: 'none',
    borderRadius: 0,
    cursor: 'pointer',
    backgroundColor: '#B2B2B2',
    color: '#FFFFFF',
};

class ModalAssignTicket extends React.Component {

    constructor(props) {
        super();
        this.state = {
            novo_responsavel: '',
            errors: [],
            loading: false,
            users: []
        }
    }

    setLoading = async (loading) => {
        await this.setState({loading: loading});
    }

    finishTicket = async () => {

        try {
            await this.setLoading(true);

            let response = await axios.post(route('ticket.assign', this.props.ticket.id), {
                novo_responsavel: this.state.novo_responsavel
            });

            if (response.status == 200) {
                this.props.handleAssigned();

            }

        } catch (e) {
            if (e.response && e.response.status === 422) {
                this.setState({errors: e.response.data.errors});
            }
            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }

    getUsers = async () => {
        try {
            await this.setLoading(true);

            const usersRoute = this.props.usersRoute || route('users.suporte');
            let response = await axios.get(usersRoute);

            if (response.status == 200) {
                this.setState({users: response.data});
            }

        } catch (e) {
            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }

    componentDidMount = async ()=>{
        await this.getUsers();
    }

    render() {

        return (

            <>
                {this.state.loading && <Loader/>}
                <style>{`
                    .modal-assign-ticket { max-width: 600px; }
                    .modal-assign-ticket .modal-content { border-radius: 0; }
                `}</style>
                <Modal show={this.props.show} onHide={this.props.handleCloseModal} dialogClassName="modal-assign-ticket">
                    <Modal.Header closeButton style={{ border: 'none', padding: '0 30px', paddingTop: 0 }}>
                        <Modal.Title style={{
                            fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
                            fontSize: '26px',
                            fontWeight: 700,
                            color: '#5B595B',
                        }}>
                            Atribuir chamado
                        </Modal.Title>
                    </Modal.Header>
                    <hr style={HR_STYLE} />
                    <Modal.Body style={{ padding: '28px 24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '6px' }}>
                            <label style={{
                                fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
                                fontSize: '23px',
                                fontWeight: 700,
                                color: '#5B595B',
                                whiteSpace: 'nowrap',
                                margin: 0,
                            }}>
                                Para:
                            </label>

                            <div style={{ flex: 1 }}>
                                <Select
                                    styles={selectStyles}
                                    placeholder="Selecione"
                                    options={this.state.users.map(user => ({ value: user.id, label: user.name }))}
                                    value={this.state.users
                                        .map(user => ({ value: user.id, label: user.name }))
                                        .find(opt => opt.value === this.state.novo_responsavel) || null}
                                    onChange={(opt) => this.setState({ novo_responsavel: opt ? opt.value : '' })}
                                />
                            </div>
                        </div>

                        {this.state.errors['novo_responsavel'] && (
                            <div style={{ color: '#CF3C3E', fontSize: '13px', marginBottom: '8px', fontFamily: "'Archivo', sans-serif" }}>
                                {this.state.errors['novo_responsavel']}
                            </div>
                        )}

                        <div style={{ textAlign: 'right', marginTop: '16px' }}>
                            <button
                                style={BUTTON_STYLE}
                                onClick={this.finishTicket}
                            >
                                Atribuir
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </>

        );
    }
}

export default ModalAssignTicket;
